import * as PathAssertionStrategies from './path-assertion-strategies';

/**
 * Generate a list of instances for all the classes received as parameter
 * @function instanciateAssertionStrategies
 * @param {Array} pathAssertionStrategies - List of strategy classes
 * @return {Array of Object} - Return a list of objects that are instances of the strategy classes
 */
const instanciateAssertionStrategies = pathAssertionStrategies => {
  return Object.values(pathAssertionStrategies).map(Strategy => new Strategy());
};

/**
 * Get an Object instance of the assertion strategy that matches with the type of path to assert
 * @function getPathAssertionStrategy
 * @param {Object} pathToAssert - An element to be evaluated that represents a path in the app
 * @return {DefaultPathAssertionStrategy} - Return an instance of the class or subclass of DefaultPathAssertionStrategy
 */
const getPathAssertionStrategy = pathToAssert => {
  let strategies = instanciateAssertionStrategies(PathAssertionStrategies);
  return (
    strategies &&
    strategies.find(strategy => strategy.appliesForPath(pathToAssert))
  );
};

/**
 * Checks if at least one of the pathsToAssert matches with the current path
 * @function somePathAsserted
 * @param {String} currentPath - The pathname of the current browser location
 * @param {Array of Object} pathsToAssert - An array of elements to be evaluated that represents a path in the app
 * @return {Boolean} - Return true if at least one of the pathsToAssert matches with the current path, otherwise false
 */
const somePathAsserted = (currentPath, pathsToAssert) => {
  if (!Array.isArray(pathsToAssert)) {
    throw new Error(
      'Function isUntrackedPath requires to pass an array of pass as parameter',
    );
  }

  return pathsToAssert.some(pathToAssert => {
    let strategy = getPathAssertionStrategy(pathToAssert);
    return strategy && strategy.testPath(pathToAssert, currentPath);
  });
};

export default somePathAsserted;
